import PropTypes from 'prop-types';

import oeURLParameterTool, {OEURLParameter} from '../lib/tools/oe-url-parameter-tool';

export const AppFlags = {
    legacy:                     'legacy',
    english:                    'english',
    import:                     'import',
    media:                      'media',
    reduced:                    'reduced',
    alpha:                      'alpha',
    beta:                       'beta',
    production:                 'production',
    devCamera:                  'devCamera',
    restrictedCamera:           'restrictedCamera',
    cutTouchShift:              'cutTouchShift',
    camAlignedLight:            'camAlignedLight',
    presSlideIndices:           'presSlideIndices',
    noSentry:                   'noSentry',
    pwa:                        'pwa',
    pwaInstall:                 'pwaInstall',
    pwaSW:                      'pwaSW'
};

AppFlags._get = function()   {
    if(this._flags) return this._flags;

    let flags = Array.isArray(config.flags) ? [...config.flags] : [];
    let flagsUrl = oeURLParameterTool.getValue(OEURLParameter.flags);
    if(flagsUrl)    {
        flagsUrl = flagsUrl.split('_');
        flags = flags.concat(flagsUrl);
    }

    this._flags = flags.filter(flag => flag != '');
    return this._flags;
};

AppFlags.get = function()   {
    return [...this._get()];
};

AppFlags.has = function(flag)   {
    if(typeof(flag) === 'string')   return this._get().includes(flag);
    if(!Array.isArray(flag))    return false;
    for(const f of flag) if(!this.has(f))    return false;
    return true;
};

AppFlags.hasOr = function(flag)   {
    if(typeof(flag) === 'string')   return this._get().includes(flag);
    if(!Array.isArray(flag))    return false;
    for(const f of flag) if(this.hasOr(f))    return true;
    return false;
};

//
export const AppMode = {
    start:                      'start',
    play:                       'play'
};

//
export class AppFontDesc {
    constructor(family = 'Roboto, sans-serif', src = 'fonts/roboto/roboto.css') {
        this.family = family;
        this.src = src;
    }
}

AppFontDesc.defaultFont = new AppFontDesc();

AppFontDesc.propTypeDesc = PropTypes.shape({
    family: PropTypes.string,
    src: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
});